"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timeZones = {
    ASIA_TOKYO: "Asia/Tokyo",
};
exports.default = timeZones;
